var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "pt-2", attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        { staticClass: "pb-0", attrs: { cols: "12", md: "6" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [
                _vm.vr.primitives.required,
                _vm.vr.primitives.maxLength(50)
              ],
              label: _vm.$t("Name"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerName,
              callback: function($$v) {
                _vm.$set(_vm.model, "consumerName", $$v)
              },
              expression: "model.consumerName"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("Phone"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerPhone,
              callback: function($$v) {
                _vm.$set(_vm.model, "consumerPhone", $$v)
              },
              expression: "model.consumerPhone"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.required, _vm.vr.primitives.email],
              label: _vm.$t("Email"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerEmail,
              callback: function($$v) {
                _vm.$set(_vm.model, "consumerEmail", $$v)
              },
              expression: "model.consumerEmail"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.special.israeliNationalId],
              label: _vm.$t("NationalID"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerNationalID,
              callback: function($$v) {
                _vm.$set(_vm.model, "consumerNationalID", $$v)
              },
              expression: "model.consumerNationalID"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("ExternalReference"),
              outlined: ""
            },
            model: {
              value: _vm.model.externalReference,
              callback: function($$v) {
                _vm.$set(_vm.model, "externalReference", $$v)
              },
              expression: "model.externalReference"
            }
          })
        ],
        1
      ),
      this.terminalStore.settings.allowVatExemptConsumers
        ? _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12", md: "6" } },
            [
              _c("v-switch", {
                staticClass: "pt-0 mt-0",
                attrs: {
                  label: _vm.$t("VATExempt"),
                  color: "error",
                  "hide-details": "true"
                },
                model: {
                  value: _vm.model.vatExempt,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "vatExempt", $$v)
                  },
                  expression: "model.vatExempt"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c("v-col", { staticClass: "hidden-sm-and-down", attrs: { cols: "12" } }),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "3" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("Street"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerAddress.street,
              callback: function($$v) {
                _vm.$set(_vm.model.consumerAddress, "street", $$v)
              },
              expression: "model.consumerAddress.street"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "2" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("House"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerAddress.house,
              callback: function($$v) {
                _vm.$set(_vm.model.consumerAddress, "house", $$v)
              },
              expression: "model.consumerAddress.house"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "2" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("Apartment"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerAddress.apartment,
              callback: function($$v) {
                _vm.$set(_vm.model.consumerAddress, "apartment", $$v)
              },
              expression: "model.consumerAddress.apartment"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "3" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("City"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerAddress.city,
              callback: function($$v) {
                _vm.$set(_vm.model.consumerAddress, "city", $$v)
              },
              expression: "model.consumerAddress.city"
            }
          })
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "py-0", attrs: { cols: "12", md: "2" } },
        [
          _c("v-text-field", {
            staticClass: "px-1",
            attrs: {
              counter: 50,
              rules: [_vm.vr.primitives.maxLength(50)],
              label: _vm.$t("Zip"),
              outlined: ""
            },
            model: {
              value: _vm.model.consumerAddress.zip,
              callback: function($$v) {
                _vm.$set(_vm.model.consumerAddress, "zip", $$v)
              },
              expression: "model.consumerAddress.zip"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }